var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyCartImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 115,
    viewBox: "0 0 85 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.365 88.7352L62.1575 88.8841L60.3146 98.2171L71.6129 90.2423L84.5842 91.9733L37 114.13L51.365 88.7352Z",
    fill: "white",
    stroke: "#E6126A",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6296 89.4894C85.6226 62.6584 74.5105 35.0158 68.3437 30.3093C64.3299 27.2499 59.6656 24.7423 54.6235 24.7722C49.5761 24.7905 44.158 27.9444 42.5338 33.0829C40.199 40.4516 47.5107 48.084 54.6945 46.8874C61.8783 45.6909 67.2118 37.833 67.6012 30.1561C67.9906 22.4792 63.8129 16.1173 58.9214 10.6958C54.9365 5.18446 19.9992 -10.0001 1.00013 16.0001",
    stroke: "#E6126A",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCartImg);
export default __webpack_public_path__ + "static/media/empty-cart-img.6a4bd6c645da927349f3db4f4aada2ed.svg";
export { ForwardRef as ReactComponent };